import { Technology } from '@node/wam-audience-builder'
import { deburr, toLower, toNumber } from 'lodash'

const helpers = {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: () => {
        const route = '/common_project/devices.json'
        const params = {
            params: {
                list_limit: 0
            }
        }
        return { route, params }
    },

    parseData: (data, countryCode2) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                label: val.label,
                isSelectable: true,
                hasChild: false,
                parentJsonKeyName: 'techno_device',
                jsonKey: {
                    ids: ['device', toNumber(val.id), countryCode2],
                    name: 'techno_device_' + val.id,
                    type: 'Techno',
                    subType: 'device'
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => (toLower(deburr(a.label)) > toLower(deburr(b.label)) ? 1 : toLower(deburr(b.label)) > toLower(deburr(a.label)) ? -1 : 0))
    },

    instanciateAll: (devices, countryCode) => {
        return devices.map(
            device =>
                new Technology({
                    id: device.id,
                    label: device.label,
                    subCategory: 'device',
                    path: ['Technology', 'Devices'],
                    countryCode
                })
        )
    }
}

export default helpers
